module.exports = __webpack_public_path__ + "static/img/1-2-2.738b6229.jpg";